/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo, useMemo } from 'react';

import { Typography } from '@mui/material';

import { HomePageProjectsLoader } from '../../skeletons/HomePageProjectsLoader';
import { getDummyArray } from '../../utils/getDummyArray';
import { createProductsListStyles } from './ProductsList.styles';

type ProductsListProps = {
  title: string;
  loading: boolean;
  className?: string;
  isEmpty: boolean;
  noItemsTitle: string;
  children: React.ReactElement<any> | React.ReactElement<any>[];
  numberOfSkeletons?: number;
};

export const ProductsList = memo<ProductsListProps>(props => {
  const { className = '', children, title, loading, isEmpty, noItemsTitle, numberOfSkeletons = 2 } = props;
  const classes = createProductsListStyles();
  const dummyArray = useMemo(() => getDummyArray({ length: numberOfSkeletons }), [numberOfSkeletons]);

  return (
    <>
      <Typography classes={{ h4: classes.title }} variant="h4" component="h4">
        {!loading && isEmpty ? noItemsTitle : title}
      </Typography>
      <div className={cx(classes.root, { [className]: className })}>
        <div className={classes.list}>
          {loading
            ? dummyArray.map(i => (
                <div key={i}>
                  <HomePageProjectsLoader />
                </div>
              ))
            : children}
        </div>
      </div>
    </>
  );
});
